define('views/pages/wishlist/offers/filter-day',['require','jquery','views/base/view','text!templates/pages/wishlist/offers/filter-day.ejs'],function(require) {
    'use strict';

    var $ = require('jquery'),
        View = require('views/base/view'),
        template = require('text!templates/pages/wishlist/offers/filter-day.ejs');

    var FilterDayView = View.extend({
        autoRender: true,
        template: template,
        tagName: 'li',
        events: {
            'click': 'toggleSelection'
        },
        listen: {
            'change:active model': 'render',
            'change:count model': 'render'
        },
        render: function() {
            View.prototype.render.apply(this, arguments); console.log('>>>', this.model.getAttributes());
            if (this.model.get('active')) {
                this.$el.addClass('active');
            } else {
                this.$el.removeClass('active');
            }
            if (!this.model.get('all')) {
                if (this.model.get('count')) {
                    this.$el.removeClass('disabled');
                } else {
                    this.$el.addClass('disabled');
                }
            }
        },
        toggleSelection: function() {
            this.model.toggleSelection();
        }
    });

    return FilterDayView;
});

